@let selectedLanguage = activeLanguage$ | async;
<tui-elastic-container *transloco="let t">
  {{ t('Sélectionner une langue') }}
  <tui-scrollbar class="mt-4 max-h-64">
    @for (selectableLocale of availableLocales; track selectableLocale.code) {
      <label tuiCell [attr.data-testid]="'lang-' + selectableLocale.code">
        <img
          class="aspect-4/3 h-6 rounded-md border-2 border-foreground-secondary object-cover"
          [alt]="selectableLocale.label"
          [src]="selectableLocale.flag | tuiFlag" />
        <span tuiTitle>{{ selectableLocale.label }}</span>
        <input
          name="locale"
          tuiRadio
          type="radio"
          [attr.data-testid]="'lang-radio-' + selectableLocale.code"
          [ngModel]="selectedLocaleId"
          [value]="selectableLocale.code"
          (ngModelChange)="setSelectedLanguageId($event)" />
      </label>
    }
  </tui-scrollbar>
  @if (selectedLocaleId !== initialLocale) {
    <div appearance="warning" class="mt-4" size="m" tuiNotification>
      {{ t("Votre page sera rechargée afin d'appliquer les changements.") }}
    </div>
  }
  <div class="mt-4 flex justify-end">
    <button data-testid="close-modal" tuiButton type="button" (click)="confirmChangeLanguage()">
      {{ t('Confirmer') }}
    </button>
  </div>
</tui-elastic-container>
